import { loggerMiddleware } from './logger-middleware';
import { sagaMiddleware } from './saga-middleware';
import { LocalStorageSync } from './sync-localstorage-middleware';

const middleware = [
    sagaMiddleware,
    ...LocalStorageSync.getMiddlewares()
];

if (process.env.NODE_ENV === 'development' && process.env.USE_REDUX_LOGGER === 'USE') {
    middleware.push(loggerMiddleware);
}

export { middleware, loggerMiddleware, sagaMiddleware, LocalStorageSync };
